export type TXMLCorrectRegexList = {
    regex: RegExp[];
    speChar: string[];
};

export const XMLRegexList: TXMLCorrectRegexList = {
    regex: [
        /&lt;.+?&gt;/g,
        /&amp;eacute;/g,
        /&amp;rsquo;/g,
        /&amp;agrave;/g,
        /&amp;egrave;/g,
        /&amp;ccedil;/g,
        /&amp;nbsp;/g,
        /&amp;Agrave;/g,
        /&amp;ocirc;/g,
        /&amp;laquo;/g,
        /&amp;raquo;/g,
        /&amp;ugrave;/g,
        /&amp;hellip;/g,
        /&amp;ucirc;/g,
        /&amp;#39;/g,
        /&amp;ecirc;/g,
        /&amp;/g,
        /&Eacute;/g,
        /&icirc;/g,
        /&Icirc;/g,
        /&acirc;/g,
        /&oelig;/g,
    ],
    speChar: [
        " ",
        "é",
        "'",
        "à",
        "è",
        "ç",
        " ",
        "À",
        "ô",
        "«",
        "»",
        "ù",
        "...",
        "û",
        "'",
        "ê",
        "&",
        "É",
        "î",
        "Î",
        "â",
        "œ",
    ],
};
